import { MenuProps } from "antd";

import { routes } from "constants/routes";
import { USER_SCOPE_ENUM, UserScope } from "interfaces";
import { DIRECT_PAYMENT_CUSTOMER_LP } from "utils/envConstants";

type MenuItem = Required<MenuProps>["items"][number];

export type ExtendMenuItem = MenuItem & {
  roles: UserScope[];
  label: string;
};

export const allMenuItems: ExtendMenuItem[] = [
  {
    label: "Договоры",
    key: `/${routes.contracts}`,
    roles: [
      USER_SCOPE_ENUM.JUNIOR_CUSTOMER,
      USER_SCOPE_ENUM.SENIOR_CUSTOMER,
      USER_SCOPE_ENUM.JUNIOR_OPERATOR,
      USER_SCOPE_ENUM.SENIOR_OPERATOR,
      USER_SCOPE_ENUM.RISK_MANAGER,
    ],
  },
  {
    label: "Заявки",
    key: `/${routes.bids}`,
    roles: [
      USER_SCOPE_ENUM.JUNIOR_CUSTOMER,
      USER_SCOPE_ENUM.SENIOR_CUSTOMER,
      USER_SCOPE_ENUM.JUNIOR_OPERATOR,
      USER_SCOPE_ENUM.SENIOR_OPERATOR,
      USER_SCOPE_ENUM.RISK_MANAGER,
      USER_SCOPE_ENUM.JUNIOR_LP,
      USER_SCOPE_ENUM.LP_RISK_MANAGER,
      USER_SCOPE_ENUM.SENIOR_LP,
    ],
  },
  {
    label: "AML проверки",
    key: `/aml-checks`,
    roles: [
      USER_SCOPE_ENUM.SENIOR_CUSTOMER,
      USER_SCOPE_ENUM.JUNIOR_CUSTOMER,
      USER_SCOPE_ENUM.SENIOR_LP,
      USER_SCOPE_ENUM.JUNIOR_LP,
      USER_SCOPE_ENUM.LP_RISK_MANAGER,
      USER_SCOPE_ENUM.SENIOR_OPERATOR,
      USER_SCOPE_ENUM.JUNIOR_OPERATOR,
      USER_SCOPE_ENUM.RISK_MANAGER,
    ],
  },
  {
    label: "Компании",
    key: `/${routes.companies}`,
    roles: [
      USER_SCOPE_ENUM.JUNIOR_OPERATOR,
      USER_SCOPE_ENUM.SENIOR_OPERATOR,
      USER_SCOPE_ENUM.USER_ADMIN,
      USER_SCOPE_ENUM.RISK_MANAGER,
    ],
  },
  {
    label: "Пользователи",
    key: `/${routes.users}`,
    roles: [USER_SCOPE_ENUM.USER_ADMIN, USER_SCOPE_ENUM.RISK_MANAGER],
  },
  {
    label: "Отчеты",
    key: `/${routes.reports}`,
    roles: [
      USER_SCOPE_ENUM.JUNIOR_CUSTOMER,
      USER_SCOPE_ENUM.SENIOR_CUSTOMER,
      USER_SCOPE_ENUM.SENIOR_OPERATOR,
      USER_SCOPE_ENUM.USER_ADMIN,
      USER_SCOPE_ENUM.RISK_MANAGER,
      USER_SCOPE_ENUM.JUNIOR_LP,
      USER_SCOPE_ENUM.SENIOR_LP,
    ],
  },
  !DIRECT_PAYMENT_CUSTOMER_LP && {
    label: "Номинальный счет",
    key: `/${routes.nominalAccount}`,
    roles: [
      USER_SCOPE_ENUM.JUNIOR_CUSTOMER,
      USER_SCOPE_ENUM.SENIOR_CUSTOMER,
      USER_SCOPE_ENUM.JUNIOR_OPERATOR,
      USER_SCOPE_ENUM.SENIOR_OPERATOR,
      USER_SCOPE_ENUM.JUNIOR_LP,
      USER_SCOPE_ENUM.SENIOR_LP,
    ],
  },
  {
    label: "Кастомизация интерфейса",
    key: `/${routes.interfaceCustomization}`,
    roles: [USER_SCOPE_ENUM.SYSTEM_ADMIN],
  },
  {
    label: "Шаблоны документов",
    key: `/${routes.documentTemplates}`,
    roles: [USER_SCOPE_ENUM.SENIOR_OPERATOR, USER_SCOPE_ENUM.JUNIOR_OPERATOR],
  },
  {
    label: "Шаблоны сообщений",
    key: `/${routes.messageTemplates}`,
    roles: [USER_SCOPE_ENUM.SYSTEM_ADMIN],
  },
  {
    label: "Управление подсказками",
    key: `/${routes.hintsManagement}`,
    roles: [USER_SCOPE_ENUM.SYSTEM_ADMIN],
  },

  {
    label: "Кошельки",
    key: `/${routes.walletsWhitelist}`,
    roles: [USER_SCOPE_ENUM.LP_RISK_MANAGER, USER_SCOPE_ENUM.RISK_MANAGER],
  },
].filter((item) => !!item);
